import * as wjcSheet from '@grapecity/wijmo.grid.sheet';

import { UnitOperationFlexSheetEventHandler } from './unit-operation-flex-sheet-event-handler';
import { enumValuesToArray } from '../../../_utils/enum-values-to-array';
import { NumberToSimulationVariableMapper } from '../mappers/number-to-simulation-variable-mapper';
import { FlexSheetValueConverter } from '../flex-sheet-value-converter';
import { ThirdPartyRefinery } from '../../../_models/_unit-operations/third-party-refinery';

import {
  ThirdPartyRefineryCellConfig,
  ThirdPartyRefinerySheetRows,
} from '../cell-config/third-party-refinery-cell-config';
import { ThirdPartyRefineryFlexSheetMapper } from '../mappers/third-party-refinery-flex-sheet-mapper';

export class ThirdPartyRefineryFlexSheetEventHandler implements UnitOperationFlexSheetEventHandler {
  constructor(private valueConverter: FlexSheetValueConverter) {}

  handle(unitOperation: ThirdPartyRefinery, spreadsheet: wjcSheet.FlexSheet, flexSheetEvent, rawValue) {
    const { row } = flexSheetEvent;

    if (enumValuesToArray(ThirdPartyRefinerySheetRows).indexOf(row) === -1) {
      flexSheetEvent.cancel = true;
      return;
    }

    const cellConfig = ThirdPartyRefineryCellConfig.find(rowConfig => rowConfig.row === row);
    const convertedValue = this.valueConverter.convert(spreadsheet, rawValue, cellConfig);

    const simulationVariableMapper = new NumberToSimulationVariableMapper();
    const mapper = new ThirdPartyRefineryFlexSheetMapper(simulationVariableMapper);

    mapper.map(unitOperation, row, convertedValue);
  }
}
